import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-section">
            <div className="brand">
              <div className="brand-icon">IR</div>
              <span className="brand-name">InnoRock</span>
            </div>
            <p className="footer-text">
              AI-Powered Consulting for Modern Businesses
            </p>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links">
              <li><a href="#services">AI Readiness Audit</a></li>
              <li><a href="#services">Automation Consulting</a></li>
              <li><a href="#services">Integration Setup</a></li>
              <li><a href="#services">Training & Workshops</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-section">
            <h3 className="footer-heading">Company</h3>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-heading">Get in Touch</h3>
            <ul className="footer-links">
              <li><a href="mailto:hello@innorock.ai">suraj@innorock.org</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p>© 2025 InnoRock. AI & IT Consulting for Modern Businesses.</p>
        </div>
      </div>
    </footer>
);

export default Footer;